import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { IcepanelDialog } from '../../../../icemedx-lib/src/components/icepaneldialog/icepaneldialog';
import { IcecontrolSettings, IcepanelsectionSettings, IcepanelSettings, SECTION_CONTROL_ALIGNMENT } from '../../../../icemedx-lib/src/components/models/icesettings';
import { provider } from '../../../../icemedx-lib/src/models/domain/provider';
import { provider_index } from '../../../../icemedx-lib/src/models/domain/provider_index';
import { diagnosis } from '../../../../icemedx-lib/src/models/ehr/diagnosis';
import { encounter } from '../../../../icemedx-lib/src/models/ehr/encounter';
import { encounterindex } from '../../../../icemedx-lib/src/models/ehr/encounterindex';
import { encounterprogressnotes } from '../../../../icemedx-lib/src/models/ehr/encounterprogressnotes';
import { basecode } from '../../../../icemedx-lib/src/models/ehr/subs/basecode';
import { encounterprogressnotesreference } from '../../../../icemedx-lib/src/models/ehr/subs/encounterprogressnotesreference';
import { observation } from '../../../../icemedx-lib/src/models/ehr/subs/observation';
import { IceTypes } from '../../../../icemedx-lib/src/models/icetypes';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { MedicalcodesService } from '../../../../icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { PatientService } from '../../../../icemedx-lib/src/services/patient/patient.service';
import { ProviderService } from '../../../../icemedx-lib/src/services/provider/provider.service';
import { AppService } from '../app.service';

@Component({
  selector: 'listofproblems',
  templateUrl: './listofproblems.component.html',
  styleUrls: ['./listofproblems.component.scss'],
  providers: [AppService, IceNavService]
})
export class ListofproblemsComponent implements OnInit {

  @Input() currentPatient: string = "";
  @Input() problems: diagnosis[] = [];
  @Input() selectedICD: any[] = [];
  @Input() notes: encounterprogressnotes[] = [];
  @Output() problemUpdate: EventEmitter<any> = new EventEmitter<any>();

  loadSelected: boolean = false;

  searchICDCtrl: IcecontrolSettings = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "100%" }, null, null, "SearchICD", "ICD Search")
    .setControlName("SearchICD")
    .setMultipleSelection(true)
    .createFormControl("", [Validators.required]);

  diagContainer: any = {};

  problemDialogRef: any = null;
  observDialogRef: any = null;
  noteDialogRef: any = null;

  constructor(
    private appSvc: AppService,
    private medCodeSvc: MedicalcodesService,
    private domainSvc: DomainService,
    private proSvc: ProviderService,
    private ptSvc: PatientService,
    public dialog: MatDialog) {
  }

  ngOnInit() {
  }

  getProblems(): diagnosis[] {
    if (this.loadSelected == false && this.selectedICD.length > 0) {
      this.loadSelected = true;
      this.searchICDCtrl.setOptions(this.selectedICD);
      this.searchICDCtrl.setMultipleSelection(true);
      this.searchICDCtrl.getFormControl().setValue(JSON.stringify(this.selectedICD));

    }
    return this.problems;
  }

  getICDSearchSelection(): any[] {
    let sel = this.searchICDCtrl.getFormControl().value;
    let ret: any[] = [];
    try {
      ret = JSON.parse(sel);
    }
    catch (e) {
      ret = [];
    }
    return ret;
  }

  getObservationList(diag: diagnosis): IcecontrolSettings {
    if (this.diagContainer[diag.diagnosis_key] == null) {
      this.diagContainer[diag.diagnosis_key] = {
        record: diag,
      };
    }

    let opts = [];
    for (let iob = 0; iob < diag.OBSERVS.length; iob++) {
      let ob = diag.OBSERVS[iob];
      let desc = "Observation: " + Iceutility.getDateTextEx(ob.observation_date, null, false)
        + ", " + PatientService.getObservationType(ob.observation_type)
        + ", " + PatientService.getSeverityType(ob.severity_type)
        + ", " + ob.description;
      opts.push({ name: desc, value: ob.observation_key });
    }

    let editAction = {
      name: IceTypes.recordQuickActionEdit.name,
      value: IceTypes.recordQuickActionEdit.value,
      iconClass: { "fas": true, "fa-edit": true }
    }

    this.diagContainer[diag.diagnosis_key].observationCtrl
      = new IcecontrolSettings(diag.diagnosis_key, {}, null, null, "", "Observations")
        .setOptions(opts)
        .setActionItems([
          editAction
        ]);
    return this.diagContainer[diag.diagnosis_key].observationCtrl;
  }

  getNoteList(diag: diagnosis): IcecontrolSettings {
    if (this.diagContainer[diag.diagnosis_key] == null) {
      this.diagContainer[diag.diagnosis_key] = {
        record: diag,
      };
    }

    let opts = [];
    for (let inte = 0; inte < diag.NOTES.length; inte++) {
      let nte = diag.NOTES[inte];
      let fndNote = this.notes.filter(n => n.encounter_progress_notes_key == nte.encounter_progress_notes_key);
      if (fndNote.length > 0) {
        let desc = AccountingService.getSourceType(Iceutility.toLong(fndNote[0].src_type)) + " " + Iceutility.getDateTextEx(fndNote[0].note_date, null, true) + ", " + fndNote[0].plain_text;
        let icons = [];
        if (diag.diagnosis_key != fndNote[0].src_key)
          icons.push({ "fas": true, "fa-solid": true, "fa-link": true });

        switch (Iceutility.toLong(fndNote[0].note_status_type)) {
          case IceTypes.notestatus.statusComplete: {
            icons.push({ "fas": true, "fa-solid": true, "fa-check": true });
            break;
          }
          case IceTypes.notestatus.statusCompleteRequired:
          case IceTypes.notestatus.statusPatientCompleteRequired: {
            icons.push({ "fas": true, "fa-regular": true, "fa-circle": true });
            break;
          }
          case IceTypes.notestatus.statusInitialDraft: {
            icons.push({ "fas": true, "fa-solid": true, "fa-circle-notch": true });
            break;
          }
          case IceTypes.notestatus.statusInProgress: {
            icons.push({ "fas": true, "fa-regular": true, "fa-spinner": true });
            break;
          }
        }

        opts.push({
          name: desc,
          value: nte.encounter_progress_notes_key,
          icons: icons
        });
      }
    }

    let editAction = {
      name: IceTypes.recordQuickActionEdit.name,
      value: IceTypes.recordQuickActionEdit.value,
      iconClass: { "fas": true, "fa-edit": true }
    }

    this.diagContainer[diag.diagnosis_key].noteListCtrl =
      new IcecontrolSettings(diag.diagnosis_key, {}, null, null, "", "Notes")
        .setOptions(opts)
        .setActionItems([
          editAction
        ]);
    return this.diagContainer[diag.diagnosis_key].noteListCtrl;
  }

  getModified(user: string, modified: any): string {
    return user + " (" + Iceutility.getDateTextEx(modified, null, true) + ")";
  }

  getDate(dt: any): string {
    return Iceutility.getDateTextEx(dt, null, false);
  }

  getProblemState(typ: any): string {
    return PatientService.getProblemState(Iceutility.toLong(typ));
  }

  getProblemStatus(typ: any): string {
    return PatientService.getProblemStatus(Iceutility.toLong(typ));
  }

  getProblemEditClass(): any {
    return { "fas": true, "fa-edit": true, "fa-2x": true };
  }

  getICDEditClass(result: any): any {
    let fndDx = this.problems.filter(dx => dx.icd_code == result.value);
    if (fndDx.length > 0)
      return { "fas": true, "fa-edit": true, "fa-2x": true };

    return { "fas": true, "fa-plus-circle": true, "fa-2x": true };
  }

  insertUpdateProblem(diag: diagnosis): void {
    this.ptSvc.insertUpdateDiagnsosis(this.currentPatient, this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), diag).subscribe(
      data => {
        this.problemUpdate.emit(data);
        this.ptSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, "Successfully saved: " + diag.title);
      },
      error => {
        console.log(JSON.stringify(error))
        this.ptSvc.logMessage(IceTypes.LOGTYPE.ltError, "Error: Saving: " + diag.title);
      }
    )
  }

  doProblemPopup(diag: diagnosis) {
    let title = "", code = "", onSet: any = NaN, resDate: any = NaN;
    let state: IceTypes.problemstate;
    let status: IceTypes.problemstatus;

    if (diag != null) {
      title = diag.title;
      code = diag.icd_code;
      onSet = Iceutility.GetLocalDate(diag.onset_of_illness_date);
      resDate = Iceutility.GetLocalDate(diag.resolution_date);
      state = diag.state_type;
      status = diag.status_type;
    }

    let sections: IcepanelsectionSettings[] = [
      new IcepanelsectionSettings("ProblemSection1", { class: ["yalla"], styles: {} }, [],
        [new IcecontrolSettings("iceinput", { width: "350px" }, null, null, "ICDCode", "ICD Code")
          .setControlName("icd_code")
          .createFormControl(code, [Validators.required])], null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical),
      new IcepanelsectionSettings("ProblemSection2", { class: ["yalla"], styles: {} }, [],
        [new IcecontrolSettings("icetextarea", { width: "350px", height: "75px" }, null, null, "Title", "Title")
          .setControlName("title")
          .createFormControl(title, [Validators.required])], null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical),
      new IcepanelsectionSettings("ProblemSection3", { class: ["yalla"], styles: {} }, [],
        [new IcecontrolSettings("icedatepicker", { placeholder: "Onset of Problem", width: "175px" }, null, null, "Onset of Problem")
          .setControlName("onset_of_illness_date")
          .createFormControl(onSet, [Validators.required])], null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical),
      new IcepanelsectionSettings("ProblemSection4", { class: ["yalla"], styles: {} }, [],
        [new IcecontrolSettings("icedatepicker", { placeholder: "Resolution Date", width: "175px" }, null, null, "Resolution Date")
          .setControlName("resolution_date")
          .createFormControl(resDate, [])], null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical),
      new IcepanelsectionSettings("ProblemSection5", { class: ["yalla"], styles: {} }, [],
        [new IcecontrolSettings("iceselect", { width: "175px" }, null, null, "State", "State of Problem")
          .setControlName("state_type")
          .createFormControl(state, [Validators.required])
          .setOptions(PatientService.getProblemStates())], null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical),
      new IcepanelsectionSettings("ProblemSection6", { class: ["yalla"], styles: {} }, [],
        [new IcecontrolSettings("iceselect", { width: "175px" }, null, null, "Status", "Status of Problem")
          .setControlName("status_type")
          .createFormControl(status, [Validators.required])
          .setOptions(PatientService.getProblemStatuses())], null)
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical),
      ];
    
    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, "Save"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Close")
    ];

    this.problemDialogRef = this.dialog.open(IcepanelDialog, {
      height: '550px',
      width: '550px',
      data: {
        record: diag,
        panel: new IcepanelSettings("", "", "Problem", "", sections, headerControls)
          .enableForm(),
      }
    });

    var ref = this.problemDialogRef;
    this.problemDialogRef.afterClosed().subscribe(result => {
      if (ref.componentInstance == null || ref.componentInstance.data == null) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>ref.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") return;
      
      let diag: diagnosis = <diagnosis>ref.componentInstance.data.record;
      let panel: IcepanelSettings = <IcepanelSettings>ref.componentInstance.data.panel;
      if (panel != null && diag != null) {
        let form = panel.getForm();
        if (form != null && form.valid) {
          for (let isec = 0; isec < panel.sections.length; isec++) {
            let sec = panel.sections[isec];
            for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
              let ctrl = sec.controls[ictrl];
              switch (ctrl.getControlName()) {
                case "icd_code": {
                  diag.icd_code = ctrl.getFormControl().value;
                  break;
                }
                case "title": {
                  diag.title = ctrl.getFormControl().value;
                  break;
                }
                case "onset_of_illness_date": {
                  diag.onset_of_illness_date = Iceutility.convertToUTCEx(ctrl.getFormControl().value);
                  break;
                }
                case "resolution_date": {
                  diag.resolution_date = Iceutility.convertToUTCEx(ctrl.getFormControl().value);
                  break;
                }
                case "state_type": {
                  diag.state_type = ctrl.getFormControl().value;
                  break;
                }
                case "status_type": {
                  diag.status_type = ctrl.getFormControl().value;
                  break;
                }
              }
            }
          }

          this.insertUpdateProblem(diag);
        }
      }
    });
  }

  doObservationPopup(observ: observation, diag: diagnosis) {
    let descText = "",
      obDate = Iceutility.GetLocalDate(),
      obType = IceTypes.observationtype.observTypeSymptom,
      obServTy = IceTypes.severitytype.servTypeMild;

    if (observ != null) {
      descText = observ.description;
      obDate = Iceutility.GetLocalDate(observ.observation_date);
      obType = Iceutility.toLong(observ.observation_type);
      obServTy = Iceutility.toLong(observ.severity_type);
    }

    let sections: IcepanelsectionSettings[] = [
      new IcepanelsectionSettings("ObDateSection", { class: ["yalla"], styles: {} }, [],
        [new IcecontrolSettings("icedatepicker", { placeholder: "Date of Observation", width: "175px" }, null, null, "Date of Observation")
          .setControlName("observation_date")
          .createFormControl(obDate, [Validators.required])], null),
      new IcepanelsectionSettings("ObTypeSection", { class: ["yalla"], styles: {} }, [],
        [new IcecontrolSettings("iceselect", { width: "175px" }, null, null, "State", "State of Problem")
          .setControlName("observation_type")
          .createFormControl(obType, [Validators.required])
          .setOptions(PatientService.getObservations())], null),
      new IcepanelsectionSettings("ObTypeSection", { class: ["yalla"], styles: {} }, [],
        [new IcecontrolSettings("iceselect", { width: "175px" }, null, null, "State", "State of Problem")
          .setControlName("severity_type")
          .createFormControl(obServTy, [Validators.required])
          .setOptions(PatientService.getSeverities())], null),
      new IcepanelsectionSettings("ObDescSection", { class: ["yalla"], styles: {} }, [],
        [new IcecontrolSettings("icetextarea", { width: "300px", height: "100px" }, null, null, "Description", "Description")
            .setControlName("description")
            .createFormControl(descText, [Validators.required])
        ], null),
    ];

    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, "Save"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Close")
    ];

    this.observDialogRef = this.dialog.open(IcepanelDialog, {
      height: '400px',
      width: '500px',
      data: {
        record: observ,
        parentrecord: diag,
        panel: new IcepanelSettings("", "", "Observation", "", sections, headerControls)
          .enableForm(),
      }
    });

    var ref = this.observDialogRef;
    this.observDialogRef.afterClosed().subscribe(result => {
      if (ref.componentInstance == null || ref.componentInstance.data == null) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>ref.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") return;

      let observ: observation = <observation>ref.componentInstance.data.record;
      let diag: diagnosis = <diagnosis>ref.componentInstance.data.parentrecord;
      let panel: IcepanelSettings = <IcepanelSettings>ref.componentInstance.data.panel;
      if (panel != null && diag != null && observ != null) {
        let form = panel.getForm();
        if (form != null && form.valid) {
          for (let isec = 0; isec < panel.sections.length; isec++) {
            let sec = panel.sections[isec];
            for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
              let ctrl = sec.controls[ictrl];
              switch (ctrl.getControlName()) {
                case "description": {
                  observ.description = ctrl.getFormControl().value;
                  break;
                }
                case "observation_date": {
                  // store standard date 
                  observ.observation_date = Iceutility.GetDateText(ctrl.getFormControl().value);
                  break;
                }
                case "observation_type": {
                  observ.observation_type = ctrl.getFormControl().value;
                  break;
                }
                case "severity_type": {
                  observ.severity_type = ctrl.getFormControl().value;
                  break;
                }
              }
            }
          }

          if (observ.observation_key == null || observ.observation_key.length == 0)
            diag.OBSERVS.push(observ);

          this.insertUpdateProblem(diag);
        }
      }
    });

  }

  doNotePopup(noteref: encounterprogressnotesreference, diag: diagnosis) {
    if (noteref == null) {
      return;
    }

    let note: encounterprogressnotes = null;

    let opts = [{ name: "Create New Note", value: "", srckey: "", srctype: IceTypes.SourceType.srcUndefined }];
    for (let inte = 0; inte < this.notes.length; inte++) {
      let nte = this.notes[inte];
      if (nte.encounter_progress_notes_key == noteref.encounter_progress_notes_key) {
        note = nte;
      }

      if (diag.diagnosis_key != nte.src_key) { // don't add notes that are apart of diagnosis
        let desc = AccountingService.getSourceType(Iceutility.toLong(nte.src_type)) + " Notes on " + Iceutility.getDateTextEx(nte.note_date, null, true);
        opts.push({ name: desc, value: nte.encounter_progress_notes_key, srckey: nte.src_key, srctype: nte.src_type });
      }
    }

    if (note == null) {
      note = new encounterprogressnotes();
      note.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
      note.src_key = "";
      note.src_type = IceTypes.SourceType.srcUndefined;
      note.trans_account = this.currentPatient;
      note.name = "0";
      note.note_date = NaN;
      note.note_status_type = IceTypes.NoteStatus.statusInitialDraft;
      //  note.encounter_progress_notes_type: number = 0;
      //  note.cfield_data: string = "";

      noteref.offline_record_status = note.offline_record_status;
    }

    let sections: IcepanelsectionSettings[] = [];
    let noteLinks = new IcecontrolSettings("iceselect", { width: "325px" }, null, null, "LinkEncounterNote", "Link to Encounter Note")
      .setControlName("encounter_progress_notes_key")
      .createFormControl(note.encounter_progress_notes_key, [])
      .setOptions(opts);

    if (note.encounter_progress_notes_key == "" || diag.diagnosis_key != note.src_key) {
      sections.push(
        new IcepanelsectionSettings("NoteSection0", { class: ["yalla"], styles: {} }, [],
          [noteLinks], null),
      );

      if (note.encounter_progress_notes_key.length > 0 && diag.diagnosis_key != note.src_key) {
        noteLinks.setDisabled(true);
      }
    }

    let dateCtrl: IcecontrolSettings = null;
    let noteCtrl: IcecontrolSettings = null;
    let authCtrl: IcecontrolSettings = null;
    let typeCtrl: IcecontrolSettings = null;
    let statCtrl: IcecontrolSettings = null;

    sections.push(
      new IcepanelsectionSettings("NoteSection1", { class: ["yalla"], styles: {} }, [],
        [
          dateCtrl = new IcecontrolSettings("icedatepicker", { placeholder: "Date of Note", width: "175px" }, null, null, "Date of Note")
            .setControlName("note_date")
            .createFormControl(Iceutility.GetLocalDate(note.note_date), [Validators.required])], null),
      new IcepanelsectionSettings("NoteSection3", { class: ["yalla"], styles: {} }, [],
        [
          authCtrl = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "300px" }, null, null, "provider_trans_account", "Author of Note")
            .setControlName("provider_trans_account")
            .createFormControl("", [Validators.required])
        ], null),
      new IcepanelsectionSettings("NoteSection4", { class: ["yalla"], styles: {} }, [],
        [
          statCtrl = new IcecontrolSettings("iceselect", { menuItems: [], width: "300px" }, null, null, "note_status_type", "Status")
            .setControlName("note_status_type")
            .createFormControl(Iceutility.toLong(note.note_status_type), [Validators.required])
            .setOptions(DomainService.getNoteStatuses())
        ], null),
      new IcepanelsectionSettings("NoteSection2", { class: ["yalla"], styles: {} }, [],
        [
          noteCtrl = new IcecontrolSettings("icetextarea", { width: "300px", height: "400px" }, null, null, "Description", "Description")
            .setControlName("plain_text")
            .createFormControl(note.plain_text, [Validators.required]),
        ], null),
    );

    noteLinks.createChangeControlEvent().subscribe(
      event => {
        let fndNote = this.notes.filter(n => n.encounter_progress_notes_key == event.value);
        if (fndNote.length > 0) {
          dateCtrl.getFormControl().setValue(Iceutility.GetLocalDate(fndNote[0].note_date));
          noteCtrl.getFormControl().setValue(fndNote[0].plain_text);
          statCtrl.getFormControl().setValue(Iceutility.toLong(fndNote[0].note_status_type));
          let fndLink = authCtrl.getOptions().filter(o => o.value == fndNote[0].provider_trans_account);
          if (fndLink.length > 0) {
            let authDesc = JSON.stringify([{ name: fndLink[0].name, value: fndLink[0].value }]);
            authCtrl.getFormControl().setValue(authDesc);
          }
          //typeCtrl
          note = fndNote[0];
          noteref.offline_record_status = IceTypes.offlineRecStatus.offlineInsert
          noteref.encounter_progress_notes_key = note.encounter_progress_notes_key;

          dateCtrl.setReadonly(true);
          noteCtrl.setReadonly(true);
          authCtrl.setReadonly(true);
          //typeCtrl.setDisabled(true);
        }
        else {
          dateCtrl.getFormControl().setValue(Iceutility.GetLocalDate());
          noteCtrl.getFormControl().setValue("");
          statCtrl.getFormControl().setValue(IceTypes.NoteStatus.statusInitialDraft);
          authCtrl.getFormControl().setValue("");
          //typeCtrl

          dateCtrl.setReadonly(false);
          noteCtrl.setReadonly(false);
          authCtrl.setReadonly(false);
          //typeCtrl.setDisabled(false);
        }
      },
      error => {
      }
    );

    this.proSvc.getPracticeProviders(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "").subscribe(
      data => {
        if (data != null && data.length > 0) {
          let opts = [];
          for (let ipro = 0; ipro < data.length; ipro++) {
            let proIdx: provider_index = data[ipro];
            opts.push({ name: proIdx.getdisplayname(false), value: proIdx.trans_account });
          }
          authCtrl.setOptions(opts);
        }
      },
      error => {
        console.log(JSON.stringify(error))
        this.ptSvc.logMessage(IceTypes.LOGTYPE.ltError, "Error: Loading practice providers.");
      });

    if (authCtrl != null && note.provider_trans_account.length > 0) {
      this.domainSvc.getProvider(note.provider_trans_account).subscribe(
        data => {
          if (data != null && data.length > 0) {
            let pro: provider = <provider>data[0];
            let authDesc = JSON.stringify([{ name: pro.getdisplayname(false), value: pro.trans_account }]);
            authCtrl.getFormControl().setValue(authDesc);
          }
        },
        error => {
          console.log(JSON.stringify(error))
          this.ptSvc.logMessage(IceTypes.LOGTYPE.ltError, "Error: Loading provider.");
        });
    }

    let headerControls = [
      new IcecontrolSettings("icesubmitbutton", { class: "fas fa-check", width: "50px" }, null, null, "Save"),
      new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "Close")
    ];

    if (note.encounter_progress_notes_key.length > 0 && diag.diagnosis_key != note.src_key) {
      headerControls.push(new IcecontrolSettings("icebutton", { class: "fas fa-solid fa-trash", width: "50px" }, null, null, "RemoveLink"));
    }

    this.noteDialogRef = this.dialog.open(IcepanelDialog, {
      height: '500px',
      width: '500px',
      data: {
        record: noteref,
        parentrecord: diag,
        panel: new IcepanelSettings("", "", "Note", "", sections, headerControls)
          .enableForm(),
      }
    });

    var ref = this.noteDialogRef;
    this.noteDialogRef.afterClosed().subscribe(result => {
      debugger;
      if (ref.componentInstance == null || ref.componentInstance.data == null) return;
      let hdrCtrl: IcecontrolSettings = <IcecontrolSettings>ref.componentInstance.data.headerCtrl;
      if (hdrCtrl == null || hdrCtrl.id == "Close") return;
      let noteref: encounterprogressnotesreference = <encounterprogressnotesreference>ref.componentInstance.data.record;

      let diag: diagnosis = <diagnosis>ref.componentInstance.data.parentrecord;
      if (hdrCtrl.id == "RemoveLink") {
        if (Iceutility.yesnomodal("Would you like to unlink this note?\nOk - to unlink this note.\nCancel - to abandon this action.")) {
          let fndNoteRefs = diag.NOTES.filter(x => x.encounter_progress_notes_reference_key != noteref.encounter_progress_notes_reference_key);
          diag.NOTES = fndNoteRefs;
          this.insertUpdateProblem(diag);
        }
        return;
      }

      let panel: IcepanelSettings = <IcepanelSettings>ref.componentInstance.data.panel;
      if (panel != null && diag != null && noteref != null) {
        let form = panel.getForm();
        if (form != null && form.valid) {
          for (let isec = 0; isec < panel.sections.length; isec++) {
            let sec = panel.sections[isec];
            for (let ictrl = 0; ictrl < sec.controls.length; ictrl++) {
              let ctrl = sec.controls[ictrl];
              switch (ctrl.getControlName()) {
                case "encounter_progress_notes_key": {
                  debugger;
                  let keyLink = ctrl.getFormControl().value;
                  if (keyLink == "") {
                    note.src_key = diag.diagnosis_key;
                    note.src_type = IceTypes.SourceType.srcDiagnosis;
                  }
                  else {
                    let fndLink = ctrl.getOptions().filter(o => o.value == keyLink);
                    if (fndLink.length > 0) {
                      note.src_key = fndLink[0].srckey;
                      note.src_type = fndLink[0].srctype;
                    }
                  }
                  break;
                }
                case "plain_text": {
                  note.plain_text = ctrl.getFormControl().value;
                  break;
                }
                case "note_date": {
                  note.note_date = Iceutility.convertToUTCEx(ctrl.getFormControl().value);
                  break;
                }
                case "note_status_type": {
                  note.note_status_type = ctrl.getFormControl().value;
                  break;
                }
                case "provider_trans_account": {
                  try {
                    let proObj = JSON.parse(ctrl.getFormControl().value);
                    if (proObj != null && proObj.length > 0) {
                      note.provider_trans_account = proObj[0].value;
                    }
                    else {
                      throw "No provider selected or error saving provider.";
                    }
                  }
                  catch (e) {
                    this.ptSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, e);
                  }
                  break;
                }
              }
            }
          }

          this.ptSvc.insertUpdateNote(this.currentPatient, this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), note).subscribe(
            data => {
              if (data == null || data.length == 0) {
                // to do reload popup to try again.
                this.ptSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, "Failed to save note.");
                return; 
              }
              let updatednote = data[0];
              this.ptSvc.logMessage(IceTypes.LOGTYPE.ltUserAlert, "Successfully saved note.");
              if (noteref.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
                noteref.encounter_progress_notes_key = updatednote.encounter_progress_notes_key;
                noteref.offline_record_status = IceTypes.offlineRecStatus.offlineNoChange;
                diag.NOTES.push(noteref);
                if (note.offline_record_status == IceTypes.offlineRecStatus.offlineInsert)
                  this.notes.push(updatednote); // this is not a link
              }
              this.insertUpdateProblem(diag);
            },
            error => {
              console.log(JSON.stringify(error))
              this.ptSvc.logMessage(IceTypes.LOGTYPE.ltError, "Error: Saving note.");
            }
          );
        }
      }
    });

  }

  ////////////////////////////////////
  // Event handlers
  onsearchICDCtrlQuery(event): void {
    let keyword: string = event["value"];
    if (keyword.length < 3) return;
    this.medCodeSvc.getCodes("ICDCODE", "", "", keyword).subscribe(
      data => {
        if (data && data.length > 0 && data[0] != null) {
          debugger;
          let icds: basecode[] = data;
          let icdOpts = icds.map((x) => { return { name: x.code + " - " + x.title, value: x.code } });
          this.searchICDCtrl.setOptions(this.searchICDCtrl.getOptions().concat(icdOpts), false);
        }
      },
      error => {
        console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
        this.ptSvc.logMessage(IceTypes.LOGTYPE.ltError, "Error: Loading diagnosis codes.");
      });
  }

  onsearchICDCtrlChange(event) {
    debugger;
  }

  addProblemClick(event): void {
    let diag: diagnosis = new diagnosis();
    diag.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
    this.doProblemPopup(diag);
  }

  onProblemClick(event, diag: diagnosis): void {
    this.doProblemPopup(diag);
  }
  onAddObservationClick(event, diag: diagnosis) {
    let observ = new observation();
    this.doObservationPopup(observ, diag);
  }
  onObservatonClick(event, diag: diagnosis): void {
    if (this.diagContainer[event["matListSettings"].tag] == null) return;
    let fndOb = diag.OBSERVS.filter(x => x.observation_key == event["item"].value);
    if (fndOb.length == 0) return;
    this.doObservationPopup(fndOb[0], diag);
  }
  onAddNoteClick(event, diag: diagnosis) {
    let note = new encounterprogressnotesreference();
    this.doNotePopup(note, diag);
  }
  onNoteClick(event, diag: diagnosis): void {
    if (this.diagContainer[event["matListSettings"].tag] == null) return;
    let fndOb = diag.NOTES.filter(x => x.encounter_progress_notes_key == event["item"].value);
    if (fndOb.length == 0) return;
    this.doNotePopup(fndOb[0], diag);
  }

  onICDResultClick(event, icdresult: any): void {
    let fndDx = this.problems.filter(dx => dx.icd_code == icdresult.value);
    if (fndDx.length > 0) {
      this.doProblemPopup(fndDx[0]);
    }
    else {
      let dX: diagnosis = new diagnosis();
      dX.icd_code = icdresult.value;
      dX.title = icdresult.name.replace(dX.icd_code + " - ", "");
      this.doProblemPopup(dX);
    }
  }
}
